<div>
	<div class="ibox-title">
		<h5>Today's Denied Visitors</h5>
	</div>

	<div class="ibox-content">
		<!--Table-->
		<div class="table-main-body">
			<p-table
				#mydt
				[scrollable]="true"
				scrollDirection="both"
				[value]="lstVisitorLog"
				[loading]="loading"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedVisitorLog"
				dataKey="VisitorLogID"
				(onFilter)="onHandleFilter($event)"
				(onSort)="onHandleSort($event)"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Filter or Select from Dropdown-->
					<tr>
						<th></th>

						<!--INSERT CUSTOM FILTERS HERE-->

						<!--FirstName-->
						<th>
							<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--LastName-->
						<th>
							<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--LogDT-->
						<th>
							<!-- <p-columnFilter type="text" field="LogDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
						</th>

						<!--ScanStation-->
						<!-- <th>
							<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown #filterScanStation [ngModel]="value" [options]="lstScanStation" (onChange)="filter($event.value)"
										placeholder="Any" [showClear]="true">
										<ng-template let-value pTemplate="item">
											<span>{{value}}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th> -->

						<!--FacilityLocationCD-->
						<!-- <th>
							<p-columnFilter field="FacilityLocationCD" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown #filterFacilityLocationCD [ngModel]="value" [options]="lstFacilityLocationCD" (onChange)="filter($event.value)"
										placeholder="Any" [showClear]="true">
										<ng-template let-value pTemplate="item">
											<span>{{value}}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th> -->

						<!--FacilityLocationName-->
						<!-- <th>
							<p-columnFilter field="FacilityLocationName" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown #filterFacilityLocationName [ngModel]="value" [options]="lstFacilityLocationName" (onChange)="filter($event.value)"
										placeholder="Any" [showClear]="true">
										<ng-template let-value pTemplate="item">
											<span>{{value}}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th> -->

						<!--Comment-->
						<!-- <th>
							<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th> -->
					</tr>

					<!--Column Names-->
					<tr style="height: 4rem">
						<th></th>

						<!--INSERT CUSTOM COLUMNS HERE-->
						<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
						<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
						<th pSortableColumn="LogDT">Date/Time<p-sortIcon field="LogDT"></p-sortIcon></th>
						<!-- <th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th> -->
						<!-- <th pSortableColumn="FacilityLocationCD">Location Code<p-sortIcon field="FacilityLocationCD"></p-sortIcon></th> -->
						<!-- <th pSortableColumn="FacilityLocationName">Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th> -->
						<!-- <th pSortableColumn="Comment">Comments<p-sortIcon field="Comment"></p-sortIcon></th> -->
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-VisitorLog>
					<tr [pSelectableRow]="VisitorLog" (dblclick)="onRowDblClick(VisitorLog)">
						<td>
							<img class="ts-Image" style="border: 1px black solid; max-width: 100%; max-height: 100%" src="{{ VisitorLog.PhotoData }}" />
						</td>

						<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ VisitorLog[col.field] }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>
